"use client";

import { ClientFingerprint } from "../types/fingerprint";

export async function buildFingerprint(
  clickId: string,
  originalPath: string,
  url: string = typeof location !== "undefined" ? location.href : ""
): Promise<ClientFingerprint> {
  const fingerprint: ClientFingerprint = {
    click_id: clickId,
    original_path: originalPath,
    // screen
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      scale: window.devicePixelRatio || 1,
    },
    navigator: {
      user_agent: navigator.userAgent,
      language: navigator.language,
      languages:
        (navigator.languages && navigator.languages.slice(0, 5)) || null,
      platform: navigator.platform,
      vendor: navigator.vendor,
    },
    timezone: (() => {
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch {
        return null;
      }
    })(),
    referrer: document.referrer || null,
    url: url,
    timestamp: Date.now(),
  };

  if ("userAgentData" in navigator) {
    try {
      const highEntropyData =
        await navigator.userAgentData?.getHighEntropyValues([
          "model",
          "platformVersion",
        ]);

      fingerprint.navigator.model = highEntropyData?.model;
      fingerprint.navigator.platform_version = highEntropyData?.platformVersion;
    } catch (e) {
      console.error("Error during getting high entropy data:", e);
    }
  }

  return fingerprint;
}
